import script from "./Layout8.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout8.vue?vue&type=script&lang=ts&setup=true"

import "./Layout8.vue?vue&type=style&index=0&id=1e4b4bbe&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4b4bbe"]])

export default __exports__